
    import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
    import {translate} from "../../services/translation/translation";
    import "./project-galleries.less";
    import ModalGallery from "@/components/modal-gallery/modal-gallery.vue";
    import MobileGallery from "@/components/mobile-gallery/mobile-gallery.vue";
    import ProjectGalleryDestop from "@/components/project-gallery-destop/project-gallery-destop.vue";


    @Component({
        components: {
            ModalGallery,
            MobileGallery,
            ProjectGalleryDestop,
        }
    })
    export default class ProjectGalleries extends Vue {
        @Prop() images;
        private data ={
            'index': 0,
            'visible' : false,
            'width' : 0,
        };
        getWidth(){
            this.data.width = screen.width;
        }
        mounted() {
            this.initGaleryView();
            this.getWidth();

            try {
                window.addEventListener('resize', this.getWidth);
                window.addEventListener('orientationchange', this.getWidth);
            } catch (e) {

            }
        }

        trans(key) {
            return translate(key);
        };
        showImg (index) {
            this.data.index = index;
            this.data.visible = true;
        };
        handleHide () {
            this.data.visible = false;
        };
        initGaleryView(){
            
            $('.project-image-container .widescreen').each(function (i, e) {
              let elem: any= $(e);
                let width: any= elem.width();
                console.log(width);
                elem.height(width * 9 / 16);
            })
            //     let projectContainer: any= $('.project-image-container').height();
            //     if(elem !== undefined){
            //         if (elem.hasClass('big')) {
            //             elem.css('height', width * 0.5625 + 4);
            //             elem.css('max-height', width * 0.5625 + 4);
            //         } else {
            //             elem.css('height', projectContainer * 0.5);
            //             elem.css('max-height', projectContainer * 0.5);
            //         }
            //     }
            // });
            //$('.project-image-container').addClass('visible');
        }


        @Watch("settingVisible", {immediate: true, deep: true})
        onSettingVisible(visible){
            this.data.visible = visible;
        }

        @Watch("showModalGallery", {immediate: true, deep: true})
        onShowModalGallery(index, visible){
            this.data.visible = visible;
            this.data.index = index;
        }

    }
